import React from 'react';

export const SmartScreenIcon = () => (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.3166 3.00022C1.3166 2.25464 1.92102 1.65022 2.6666 1.65022L13.3333 1.65022C14.0789 1.65022 14.6833 2.25464 14.6833 3.00022L14.6833 8.778C14.6833 9.52358 14.0789 10.128 13.3333 10.128L2.6666 10.128C1.92102 10.128 1.3166 9.52358 1.3166 8.778L1.3166 3.00022ZM2.6666 0.35022C1.20305 0.35022 0.0166016 1.53666 0.0166016 3.00022L0.0166016 8.778C0.0166016 10.2416 1.20305 11.428 2.6666 11.428L13.3333 11.428C14.7968 11.428 15.9833 10.2416 15.9833 8.778L15.9833 3.00022C15.9833 1.53667 14.7968 0.35022 13.3333 0.35022L2.6666 0.35022ZM12.386 12.4077L3.24454 12.4077L3.24454 12.704C3.24454 13.4404 3.84149 14.0373 4.57787 14.0373L11.0527 14.0373C11.789 14.0373 12.386 13.4404 12.386 12.704V12.4077Z"
            fill="currentColor"
            fillOpacity="1"
        />
    </svg>
);
